export const en = {
  "AddTranslation":"Add Translation"
};
